import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "memberNumberInput",
    "memberNumberErrorText",
    "memberNumberErrorIcon",
  ];

  initialize() {
    this.update = this.update.bind(this);

    if (this.data.get("validation-regex") != null) {
      this.memberNumberValidationRegex = new RegExp(
        this.data.get("validation-regex"),
      );
    }
  }

  connect() {
    this.memberNumberInputTarget.addEventListener("input", this.update);
  }

  disconnect() {
    this.memberNumberInputTarget.removeEventListener("input", this.update);
  }

  update() {
    // if regex is available
    if (this.memberNumberValidationRegex) {
      if (this.isMemberNumberValid()) {
        this.memberNumberInputTarget.classList.remove("error", "border-error");
        this.memberNumberErrorTextTarget.classList.add("hidden");
        this.memberNumberErrorIconTarget.classList.add("hidden");
      } else {
        this.memberNumberInputTarget.classList.add("error", "border-error");
        this.memberNumberErrorTextTarget.classList.remove("hidden");
        this.memberNumberErrorIconTarget.classList.remove("hidden");
      }
    }
  }

  isMemberNumberValid() {
    let memberNumber = this.memberNumberInputTarget.value;

    if (memberNumber.length >= 8) {
      return this.memberNumberValidationRegex.test(memberNumber);
    } else {
      return true;
    }
  }
}
